import { DropdownItem, Popconfirm } from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DirtyConfirmation.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'input-data-dirty-confirmation',
);
addTranslations(translations);

export type InputActionFactory = (
  copy: boolean,
  confirm?: boolean,
) => () => void;

export interface DirtyConfirmationProps {
  action: InputActionFactory;
  actionType: 'copy' | 'impute';
  sampleType: 'group' | 'description';
}

export function DirtyConfirmation({
  action,
  actionType,
  sampleType,
}: DirtyConfirmationProps) {
  const { t } = useTranslation();

  return (
    <Popconfirm
      id={`confirm-${actionType}-overwrite-${sampleType}`}
      cancelText={t('button.cancel')}
      description={t(`overwrite-dirty-description`)}
      okText={t('button.overwrite')}
      onConfirm={action(actionType === 'copy')}
      stopClickPropagation
      title={t(`title-${actionType}`)}
    >
      <DropdownItem>{t(`button.${actionType}-${sampleType}`)}</DropdownItem>
    </Popconfirm>
  );
}
